import { Link } from 'react-router-dom'

type ActionItem = {
  id: string
  item?: string
  done?: boolean
}

type Conversation = {
  id: string
  title?: string
  date_created?: string
  summary?: string
  action_items?: ActionItem[]
  dates?: Array<{ title?: string; datetime_start?: string }>
  emails?: Array<{ subject?: string; body?: string }>
  clients?: Array<{ first_name?: string; last_name?: string; email?: string }>
}

type ClientRecord = {
  id: string
  first_name?: string
  last_name?: string
  email?: string
  company?: string
}

type PreMeetingViewProps = {
  activeEvent: {
    id: string
    title: string
  } | null | undefined
  details: {
    clients: ClientRecord[]
    conversations: Conversation[]
  } | null
}

const PreMeetingView = ({ activeEvent, details }: PreMeetingViewProps) => {
  return (
    <>
      <div className="hero-card-adaptive pre-meeting">
        <div className="hero-content">
          <h1 className="hero-title">Your call starts soon</h1>
          <p className="hero-subtitle">
            {activeEvent?.title || 'Upcoming Call'} • Bev has your briefing ready.
          </p>
          <div className="hero-actions">
            <Link 
              to={activeEvent ? `/calendar?view=Month#${activeEvent.id}` : '/calendar?view=Month'} 
              className="hero-btn primary"
            >
              Open Briefing
            </Link>
            <button type="button" 
              className="hero-btn secondary"
              onClick={() => window.dispatchEvent(new CustomEvent('toggle-voice-agent'))}
            >
              Talk to Bev
            </button>
          </div>
        </div>
      </div>

      <div className="home-section">
        <p className="eyebrow">Call Briefing</p>
        <div className="home-grid-adaptive">
          <div className="home-panel">
            <h2 className="home-highlight-title" style={{ marginBottom: 16 }}>👥 Linked Contacts</h2>
            <div className="home-action-items-list" style={{ gridTemplateColumns: '1fr' }}>
              {details?.clients && details.clients.length > 0 ? (
                details.clients.slice(0, 3).map(client => (
                  <Link key={client.id} to={`/contact/${client.id}`} className="home-action-item">
                    <div className="home-action-item-text">
                      <strong>{[client.first_name, client.last_name].filter(Boolean).join(' ') || client.email}</strong>
                      <p className="muted" style={{ margin: '4px 0 0', fontSize: '13px' }}>{client.company || 'Private Contact'}</p>
                    </div>
                    <span className="adaptive-item-badge done">Verified</span>
                  </Link>
                ))
              ) : (
                <div className="home-action-item" style={{ cursor: 'default' }}>
                  <p className="muted" style={{ margin: 0 }}>No linked contacts found for this event.</p>
                </div>
              )}
            </div>
          </div>

          <div className="home-panel">
            <h2 className="home-highlight-title" style={{ marginBottom: 16 }}>☎️ Recent Conversations</h2>
            <div className="home-action-items-list" style={{ gridTemplateColumns: '1fr' }}>
              {details?.conversations && details.conversations.length > 0 ? (
                details.conversations.map(conv => (
                  <Link key={conv.id} to={`/conversation/${conv.id}`} className="home-action-item" style={{ display: 'block' }}>
                    <div className="home-action-item-text" style={{ marginBottom: 8 }}>
                      <strong>{conv.title || 'Recent Call'}</strong>
                    </div>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
                      {conv.dates && conv.dates.length > 0 && (
                        <span className="due-date-pill" style={{ background: '#f0f4ff', color: '#444' }}>
                          📅 {conv.dates.length} Dates
                        </span>
                      )}
                      {conv.clients && conv.clients.length > 0 && (
                        <span className="due-date-pill" style={{ background: '#f5f3ff', color: '#444' }}>
                          👥 {conv.clients.length} Contacts
                        </span>
                      )}
                      {conv.action_items && conv.action_items.length > 0 && (
                        <span className="due-date-pill" style={{ background: '#fef2f2', color: '#444' }}>
                          ✏️ {conv.action_items.length} Tasks
                        </span>
                      )}
                    </div>
                  </Link>
                ))
              ) : (
                <div className="home-action-item" style={{ cursor: 'default' }}>
                  <p className="muted" style={{ margin: 0 }}>No recent conversations found.</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      
      {/* <div className="home-section">
        <p className="eyebrow">Preparation</p>
        <div className="home-panel">
          <h2 className="home-highlight-title" style={{ marginBottom: 16 }}>📋 What You Need to Know</h2>
          <div className="home-action-items-list" style={{ gridTemplateColumns: '1fr' }}>
            <div className="home-action-item" style={{ cursor: 'default', display: 'block' }}>
              <div className="home-action-item-text" style={{ whiteSpace: 'normal', marginBottom: 8 }}>
                <strong>Suggested Talking Points</strong>
              </div>
              <p className="muted" style={{ fontSize: '14px', lineHeight: '1.6' }}>
                • Reconfirm the project timeline<br/>
                • Mention the latest feature update<br/>
                • Ask about their Q2 budget goals
              </p>
            </div>
          </div>
        </div>
      </div> */}
    </>
  )
}

export default PreMeetingView
